import { createContext, useContext, useState, useEffect } from 'react';
import { translations, countries } from '../translations';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('es');

  useEffect(() => {
    const savedLanguage = localStorage.getItem('ramiro-tattoo-language');
    if (savedLanguage && translations[savedLanguage]) {
      setLanguage(savedLanguage);
    }
  }, []);

  const changeLanguage = (lang) => {
    if (translations[lang]) {
      setLanguage(lang);
      localStorage.setItem('ramiro-tattoo-language', lang);
    }
  };

  const t = translations[language];
  const c = countries[language];

  return (
    <LanguageContext.Provider value={{ language, changeLanguage, t, c }}>
      {children}
    </LanguageContext.Provider>
  );
};
